module.exports = __webpack_public_path__ + "static/4-8350fba3a0c9399d283c76ca5d8248e0.jpg";